const shared = {
  isTouch: false,
  scrollTop: window.scrollY === undefined ? window.pageYOffset : window.scrollY,
  CSS: {
    fixed: 'is-fixed',
    active: 'is-active',
    open: 'is-open',
    menuOpen: 'is-menu-open',
    loading: 'is-loading',
  },
};

const documentTouchstart = () => {
  shared.isTouch = true;
  document.documentElement.classList.remove('no-touch');
  document.documentElement.classList.add('is-touch');
  document.removeEventListener('touchstart', documentTouchstart);
  document.dispatchEvent(new Event('touchdetected'));
};

document.addEventListener('touchstart', documentTouchstart);

[].forEach.call(document.querySelectorAll('[href="#"]'), link => {
  link.addEventListener('click', event => event.preventDefault());
});

window.addEventListener('scroll', () => {
  shared.scrollTop =
    window.scrollY === undefined ? window.pageYOffset : window.scrollY;
});

export default shared;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/modules/shared.js